export const CLOTHING_PATH_SEPARATOR = ' > ';

const MEN_TOPS = {
  'T-Shirts': ['Basic', 'Graphic', 'Polo', 'Long Sleeve', 'Oversized', 'Other'],
  Shirts: ['Casual', 'Dress', 'Oxford', 'Flannel', 'Linen', 'Other'],
  Polos: ['Classic', 'Slim', 'Relaxed', 'Other'],
  Sweaters: ['Pullover', 'Cardigan', 'Turtleneck', 'Other'],
  'Hoodies & Sweatshirts': ['Hoodie', 'Zip-up', 'Crewneck', 'Other'],
  'Tank Tops': ['Basic', 'Athletic', 'Other'],
};

const WOMEN_TOPS = {
  Blouses: ['Casual', 'Dressy', 'Peplum', 'Wrap', 'Other'],
  'T-Shirts': ['Basic', 'Graphic', 'Fitted', 'Oversized', 'Other'],
  Shirts: ['Button-down', 'Oversized', 'Linen', 'Other'],
  'Tanks & Camis': ['Basic', 'Lace', 'Silk', 'Other'],
  Sweaters: ['Pullover', 'Cardigan', 'Turtleneck', 'Cropped', 'Other'],
  'Hoodies & Sweatshirts': ['Hoodie', 'Zip-up', 'Crewneck', 'Other'],
  'Crop Tops': ['Basic', 'Knit', 'Athletic', 'Other'],
};

const MEN_BOTTOMS = {
  Jeans: ['Skinny', 'Slim', 'Straight', 'Relaxed', 'Bootcut', 'Other'],
  Trousers: ['Chinos', 'Dress', 'Cargo', 'Linen', 'Other'],
  Shorts: ['Casual', 'Cargo', 'Athletic', 'Dress', 'Other'],
  Joggers: ['Fleece', 'Slim', 'Relaxed', 'Other'],
};

const WOMEN_BOTTOMS = {
  Jeans: ['Skinny', 'Straight', 'Wide Leg', 'Mom', 'Bootcut', 'Other'],
  Trousers: ['Wide Leg', 'Straight', 'Cropped', 'Linen', 'Other'],
  Leggings: ['Basic', 'Athletic', 'Leather-look', 'Other'],
  Shorts: ['Denim', 'Linen', 'Athletic', 'Bermuda', 'Other'],
  Skirts: ['Mini', 'Midi', 'Maxi', 'Pencil', 'Pleated', 'Other'],
};

const KIDS_TOPS = {
  'T-Shirts': ['Basic', 'Graphic', 'Polo', 'Other'],
  Shirts: ['Casual', 'School', 'Other'],
  Sweaters: ['Pullover', 'Cardigan', 'Other'],
  Hoodies: ['Pullover', 'Zip-up', 'Other'],
};

const KIDS_BOTTOMS = {
  Jeans: ['Slim', 'Straight', 'Relaxed', 'Other'],
  Trousers: ['School', 'Casual', 'Joggers', 'Other'],
  Shorts: ['Casual', 'Athletic', 'Other'],
  Leggings: ['Basic', 'Printed', 'Other'],
};

const BABY_TOPS = {
  Bodysuits: ['Short Sleeve', 'Long Sleeve', 'Sleeveless', 'Other'],
  Tops: ['T-Shirt', 'Sweater', 'Cardigan', 'Other'],
};

const BABY_BOTTOMS = {
  Pants: ['Leggings', 'Joggers', 'Jeans', 'Other'],
  Shorts: ['Casual', 'Denim', 'Other'],
};

const OUTERWEAR = {
  Jackets: ['Denim', 'Bomber', 'Puffer', 'Leather', 'Windbreaker', 'Other'],
  Coats: ['Trench', 'Wool', 'Puffer', 'Parka', 'Other'],
  Blazers: ['Single-breasted', 'Double-breasted', 'Casual', 'Other'],
  Vests: ['Puffer', 'Knit', 'Tailored', 'Other'],
};

const ACTIVEWEAR = {
  Tops: ['T-Shirt', 'Tank', 'Long Sleeve', 'Sports Bra', 'Other'],
  Bottoms: ['Leggings', 'Shorts', 'Joggers', 'Track Pants', 'Other'],
  Sets: ['Two-piece', 'Tracksuit', 'Other'],
};

const SWIMWEAR = {
  'One-piece': ['Classic', 'Sport', 'Other'],
  Bikini: ['Triangle', 'Bandeau', 'High-waist', 'Other'],
  'Swim Trunks': ['Short', 'Mid', 'Long', 'Other'],
  'Rash Guards': ['Short Sleeve', 'Long Sleeve', 'Other'],
  'Cover-ups': ['Dress', 'Kaftan', 'Sarong', 'Other'],
};

export const CLOTHING_CATEGORY_TREE = {
  Men: {
    Tops: MEN_TOPS,
    Bottoms: MEN_BOTTOMS,
    Outerwear: OUTERWEAR,
    'Activewear & Sportswear': ACTIVEWEAR,
    Swimwear: SWIMWEAR,
    'Suits & Formalwear': {
      Suits: ['Two-piece', 'Three-piece', 'Tuxedo', 'Other'],
      Blazers: ['Single-breasted', 'Double-breasted', 'Other'],
      'Dress Shirts': ['Classic', 'Slim', 'French Cuff', 'Other'],
      'Dress Trousers': ['Flat Front', 'Pleated', 'Other'],
    },
    'Traditional & Occasionwear': {
      Galabeya: ['Cotton', 'Linen', 'Embroidered', 'Other'],
      Thobe: ['Classic', 'Embroidered', 'Other'],
      'Occasion Sets': ['Wedding Guest', 'Formal', 'Other'],
    },
  },
  Women: {
    Tops: WOMEN_TOPS,
    Bottoms: WOMEN_BOTTOMS,
    'Casual Dresses & Jumpsuits': {
      Dresses: ['Casual', 'Midi', 'Maxi', 'Mini', 'Evening', 'Cocktail', 'Other'],
      Jumpsuits: ['Casual', 'Formal', 'Wide Leg', 'Other'],
      Rompers: ['Casual', 'Linen', 'Other'],
    },
    Outerwear: OUTERWEAR,
    'Activewear & Sportswear': ACTIVEWEAR,
    Swimwear: SWIMWEAR,
    'Suits & Formalwear': {
      Blazers: ['Tailored', 'Oversized', 'Cropped', 'Other'],
      'Matching Sets': ['Skirt Suit', 'Trouser Suit', 'Other'],
      'Formal Dresses': ['Evening', 'Cocktail', 'Other'],
    },
    'Abayas & Kaftans': {
      Abaya: ['Classic', 'Embroidered', 'Open', 'Other'],
      Kaftan: ['Casual', 'Embellished', 'Other'],
      Jalabiya: ['Cotton', 'Linen', 'Embroidered', 'Other'],
      'Occasion Sets': ['Engagement', 'Wedding Guest', 'Other'],
    },
    Maternity: {
      Tops: ['T-Shirt', 'Blouse', 'Nursing', 'Other'],
      Dresses: ['Casual', 'Maxi', 'Nursing', 'Other'],
      Bottoms: ['Leggings', 'Jeans', 'Trousers', 'Other'],
    },
  },
  Kids: {
    Tops: KIDS_TOPS,
    Bottoms: KIDS_BOTTOMS,
    Dresses: {
      Casual: ['Cotton', 'Printed', 'Other'],
      Party: ['Tulle', 'Sequin', 'Other'],
      School: ['Pinafore', 'Shirt Dress', 'Other'],
    },
    Outerwear: OUTERWEAR,
    'Activewear & Sportswear': ACTIVEWEAR,
    Swimwear: SWIMWEAR,
    'School Uniforms': {
      Shirts: ['Polo', 'Dress Shirt', 'Other'],
      Trousers: ['School', 'Shorts', 'Other'],
      Skirts: ['Pleated', 'A-line', 'Other'],
      Sets: ['Full Uniform', 'PE Kit', 'Other'],
    },
    Sets: {
      'Two-piece': ['Casual', 'Smart', 'Other'],
      Tracksuits: ['Basic', 'Sport', 'Other'],
    },
  },
  Babies: {
    'Bodysuits & Onesies': {
      Bodysuits: ['Short Sleeve', 'Long Sleeve', 'Sleeveless', 'Other'],
      Onesies: ['Footed', 'Snap-front', 'Other'],
    },
    Tops: BABY_TOPS,
    Bottoms: BABY_BOTTOMS,
    Dresses: {
      Casual: ['Cotton', 'Knit', 'Other'],
      Occasion: ['Lace', 'Embroidered', 'Other'],
    },
    'Occasion Wear': {
      Dresses: ['Lace', 'Embroidered', 'Tulle', 'Party', 'Other'],
      Sets: ['Christening', 'Wedding Guest', 'Formal', 'Gift Set', 'Other'],
      Suits: ['Boy Suit', 'Formal', 'Other'],
      Rompers: ['Formal', 'Embellished', 'Other'],
    },
    Outerwear: {
      Jackets: ['Lightweight', 'Puffer', 'Denim', 'Other'],
      Coats: ['Puffer', 'Fleece', 'Other'],
      Cardigans: ['Knit', 'Button', 'Other'],
    },
    Swimwear: SWIMWEAR,
    Sets: {
      'Two-piece': ['Casual', 'Gift Set', 'Other'],
      'Three-piece': ['Casual', 'Occasion', 'Other'],
    },
    Accessories: {
      Hats: ['Sun Hat', 'Beanie', 'Cap', 'Other'],
      Bibs: ['Bandana', 'Waterproof', 'Other'],
      Socks: ['Ankle', 'Crew', 'Other'],
    },
  },
};

export const CLOTHING_AUDIENCES = Object.keys(CLOTHING_CATEGORY_TREE);

export function isClothingListingCategory(category) {
  return category === 'Clothing';
}

export function joinClothingSubcategoryPath(parts) {
  return parts.filter(Boolean).join(CLOTHING_PATH_SEPARATOR);
}

export function parseClothingSubcategoryPath(value) {
  if (!value) {
    return { audience: '', type: '', subtype: '', style: '' };
  }
  const [audience = '', type = '', subtype = '', style = ''] = String(value).split(CLOTHING_PATH_SEPARATOR);
  return { audience, type, subtype, style };
}

export function getClothingTypes(audience) {
  return Object.keys(CLOTHING_CATEGORY_TREE[audience] || {});
}

export function getClothingSubtypes(audience, type) {
  const node = CLOTHING_CATEGORY_TREE[audience]?.[type];
  if (!node || Array.isArray(node)) return [];
  return Object.keys(node);
}

export function getClothingStyles(audience, type, subtype) {
  const node = CLOTHING_CATEGORY_TREE[audience]?.[type]?.[subtype];
  return Array.isArray(node) ? node : [];
}

export function getClothingSubcategoriesForBrowse() {
  return CLOTHING_AUDIENCES;
}
